import { CalculusTFunction } from '@retail/calculus/i18n';
import dayjs from 'dayjs';
import * as yup from 'yup';

const today = new Date();

export const dateRangeSchema = (t: CalculusTFunction) => {
  return yup.object({
    fromDate: yup
      .date()
      .required(t('calculus.error.requiredField'))
      .default(today)
      .min(dayjs(today).subtract(1, 'day').toDate(), t('calculus.error.minDate')),
    toDate: yup.date().default(null).nullable().optional(),
  });
};

export type DateRangeSchema = yup.InferType<ReturnType<typeof dateRangeSchema>>;
